import { DeploymentConfig } from "util/stdtypes";

const siloConfig = {
    zdf: {
        themeKey: "zdfHeuteDark",
    },
};

export const firebaseConfig = {
    apiKey: "AIzaSyA72UguOvSVFCCleQ60HwTfCyhAMzbXkPU",
    authDomain: "zdf-d01-g-pub-social-0.firebaseapp.com",
    databaseURL: "https://zdf-d01-g-pub-social-0-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "zdf-d01-g-pub-social-0",
    storageBucket: "zdf-d01-g-pub-social-0.firebasestorage.app",
    messagingSenderId: "447293649377",
    appId: "1:447293649377:web:9477dc4a89007a295222a0",
};

export const deploymentConfigMap: Record<string, DeploymentConfig> = {
    local: {
        host: `http://${window.location.hostname}:5000`,
        firebaseConfig: firebaseConfig,
        emulateFirebase: true,
        defaultToAdminDash: true,
        adminEmailDomain: "admin.org",
        ssoDebug: true,
        storagePrefix: "https://firebasestorage.googleapis.com/v0/b/zdf-d01-g-pub-social-0.firebasestorage.app/o",
        defaultFeatures: {
            zdf: {
                question: {
                    human_premoderation: true,
                },
                topic: {
                    human_premoderation: true,
                },
                simpleComments: {
                    human_premoderation: true,
                },
                article: {
                    teaserOnlyAdminButton: true,
                },
                profile: {
                    profileanswers: false,
                }
            }
        },
    },
    production: {
        host: "https://psi.zdf.de",
        firebaseConfig: firebaseConfig,
        storagePrefix: "https://firebasestorage.googleapis.com/v0/b/zdf-d01-g-pub-social-0.firebasestorage.app/o",
        publicWebPushKey: "BL-cqML2c0ZP7x9Ghd2wV69ZRQ_5cPSAu1Ia3WcH2y-dAx4MQyoBZVH1dT9fKtqaQQCK4_JXxD-Nwm2ywOmSTPA",
        pushNotificationsOnParentWindow: false,
        siloConfig: siloConfig,
        defaultFeatures: {
            zdf: {
                question: {
                    human_premoderation: true
                },
                topic: {
                    human_premoderation: true

                },
                simpleComments: {
                    human_premoderation: true
                },
                article: {
                    teaserOnlyAdminButton: true,
                },
                profile: {
                    profileanswers: false,
                }
            }
        },
    },
};

export const domainToDeploymentMap: Record<string, string> = {
    "psi.zdf.de": "production",
    localhost: "local",
    test: "production",
};
